import { action } from 'satcheljs';
import type { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export const initializeGroupsNudge = action(
    'INITIALIZE_GROUPS_NUDGE',
    (infobar: InfoBarHostViewState, itemId: string) => ({
        infobar,
        itemId,
    })
);
